import React from 'react';
import classNames from 'classnames';
import styles from './Modal.module.css';
import { CtaButton } from './../CtaButton/CtaButton';

export interface ModalProps {
  body: React.ReactNode;
  closeButton: string;
  closeTestId?: string;
  canClose: boolean;
  doneButton: string;
  doneDisabled?: boolean;
  doneTestId?: string;
  header: string;
  isWarningButtonPresent: boolean;
  modalSize: 'small' | 'medium' | 'large';
  onClose?: () => void;
  onSuccess?: () => void;
  isOpen: boolean;
}

export default function Modal({
  body,
  closeButton,
  closeTestId,
  canClose,
  doneButton,
  doneDisabled = false,
  doneTestId,
  header,
  isWarningButtonPresent,
  modalSize = 'medium',
  onClose,
  onSuccess,
  isOpen = false,
}: ModalProps) {
  if (!isOpen) return null;
  return (
    <div className={styles.modalContainer}>
      <div
        className={styles.modalContainerBG}
        onClick={() => {
          if (canClose) onClose?.();
        }}
      />
      <div className={styles.modal}>
        <div className={classNames(styles.root, styles[modalSize])}>
          <div className={styles.headerContainer}>
            <div className={styles.header}>{header}</div>
            {canClose && (
              <div
                className={styles.close}
                onClick={() => {
                  onClose?.();
                }}
              >
                x
              </div>
            )}
          </div>
          <div className={styles.body}>{body}</div>
          <div className={styles.footer}>
            <CtaButton
              dataTestId={closeTestId}
              disabled={!canClose}
              label={closeButton}
              onClick={() => {
                onClose?.();
              }}
              size={'large'}
            />
            <CtaButton
              dataTestId={doneTestId}
              disabled={doneDisabled}
              label={doneButton}
              onClick={async () => {
                await onSuccess?.();
              }}
              primary={isWarningButtonPresent}
              size={'large'}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
